import CircularProgress from '@material-ui/core/CircularProgress';
import React from 'react';

interface Props {
  size?: number;
  thickness?: number;
}

export const Loading: React.FunctionComponent<Props> = ({ size, thickness }) => (
  <CircularProgress color="secondary" size={size} thickness={thickness ?? 6} />
);



// WEBPACK FOOTER //
// /codebuild/output/src891534606/src/modules/web/src/js/view/components/core/loading.component.tsx